// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fixit-dialog__desktop,.v-dialog:not(.v-dialog--fullscreen){max-height:100%!important;z-index:1000}.fixit-dialog__fullscreen{z-index:1000}.fixit-dialog__fit-to-side{background-color:#fff;bottom:0;margin:0;min-height:calc(100% - 60px);position:absolute;right:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
